import { Badge, Grid, Tag, Tooltip, Typography } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { formatDateForDisplay } from '@shared/utils/dateUtils';
import { buildColumns } from 'Utils/tableUtils';
import { CONNECTION_TYPE_CONFIG } from '@shared/components/ConnectionTypeTag';
import { CONNECTION_TYPES } from '@shared/constants/connectionTypes';
import { ActionsDropdown } from './ActionsDropdown';

const { Text } = Typography;
const { useBreakpoint } = Grid;

export const getColumns = () => {
  const screens = useBreakpoint();
  const compactActionsCol = !screens.xl;

  const baseColumnConfig = {
    width: '10em',
  };

  const columnsConfig = [
    {
      title: 'Aseguradora',
      dataIndex: 'name',
      width: '16em',
      render: (value) => <Text strong>{value}</Text>,
    },
    {
      title: 'Estado operativo',
      dataIndex: 'quotable',
      width: '14em',
      render: (value) => (
        <Tag
          icon={<Badge status={value ? 'success' : 'error'} style={{ marginRight: 4 }} />}
          color={value ? 'success' : 'error'}
          style={{ borderRadius: 12, paddingBlock: 2, fontSize: 13 }}
        >
          <Text strong style={{ color: 'inherit' }}>{value ? 'Lista para cotizar' : 'Inactiva'}</Text>
        </Tag>
      ),
      onCell: (record) => (!record.createdAt ? { colSpan: 0 } : {}),
    },
    {
      title: 'Conexión por API',
      dataIndex: 'connectionTypes',
      render: (connectionTypes) => {
        const value = connectionTypes?.find((ct) => ct.code === 'api')?.brandEnabled;
        return (
          <Tag
            color={value ? CONNECTION_TYPE_CONFIG[CONNECTION_TYPES.API].color : undefined}
            style={{
              margin: 0,
              paddingBlock: 2,
              borderRadius: 12,
              opacity: value ? 1 : 0.6,
            }}
          >
            <Text strong style={{ color: 'inherit' }}>{value ? 'Habilitada' : 'No habilitada'}</Text>
          </Tag>
        );
      },
      onCell: (record) => (!record.createdAt ? { colSpan: 0 } : {}),
    },
    {
      title: 'Conexión por Bot',
      dataIndex: 'connectionTypes',
      render: (connectionTypes) => {
        const value = connectionTypes?.find((ct) => ct.code === 'rpa')?.brandEnabled;
        return (
          <Tag
            color={value ? CONNECTION_TYPE_CONFIG[CONNECTION_TYPES.RPA].color : undefined}
            style={{
              margin: 0,
              paddingBlock: 2,
              borderRadius: 12,
              opacity: value ? 1 : 0.6,
            }}
          >
            <Text strong style={{ color: 'inherit' }}>{value ? 'Habilitada' : 'No habilitada'}</Text>
          </Tag>
        );
      },
      onCell: (record) => (!record.createdAt ? { colSpan: 0 } : {}),
    },
    {
      title: 'Convenios',
      dataIndex: 'agreementCount',
      render: (value) => {
        const { active: activeCount } = value ?? {};
        if (!activeCount) return <Text>-</Text>;
        return <Text>{activeCount} activo{activeCount > 1 ? 's' : ''}</Text>;
      },
      onCell: (record) => (!record.createdAt ? { colSpan: 0 } : {}),
    },
    {
      title: 'Fecha de creación',
      dataIndex: 'createdAt',
      render: (value, record) => (
        record.createdAt
          ? formatDateForDisplay(value)
          : <><Text type='secondary' italic>Aún no se ha agregado esta aseguradora.</Text> 😔</>
      ),
      onCell: (record) => (!record.createdAt ? { colSpan: 6 } : {}),
    },
    {
      title: 'Fecha de actualización',
      dataIndex: 'updatedAt',
      render: (value) => formatDateForDisplay(value),
      onCell: (record) => (!record.createdAt ? { colSpan: 0 } : {}),
    },
    {
      title: compactActionsCol ? (
        <Tooltip title='Acciones'>
          <FontAwesomeIcon icon={faEllipsisV} style={{ width: '100%' }} />
        </Tooltip>
      ) : (
        'Acciones'
      ),
      width: '4em',
      render: (_, record) => (
        <ActionsDropdown record={record} compact={compactActionsCol} />
      ),
    },
  ];

  const finalColumnsConfig = columnsConfig.map((column) => ({
    ...column,
    ...(typeof column.title === 'string' && { title: <span style={{ whiteSpace: 'nowrap' }}>{column.title}</span> }),
  }));

  return buildColumns(finalColumnsConfig, baseColumnConfig);
};
